export default {
  MyClass: require('./MyClass').default,
  DetailClass: require('./DetailClass').default,
}